import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const SW_CLEANUP_KEY = 'kyro_sw_cleanup_done';

function runApp() {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  serviceWorkerRegistration.register();
}

// One-time: clear any existing SW and reload so devices stuck on old cache-first SW get fresh content (fixes "Unexpected token '<'" on some devices).
if (
  typeof navigator !== 'undefined' &&
  'serviceWorker' in navigator &&
  navigator.serviceWorker.controller &&
  !sessionStorage.getItem(SW_CLEANUP_KEY)
) {
  sessionStorage.setItem(SW_CLEANUP_KEY, '1');
  navigator.serviceWorker.ready.then((reg) =>
    reg.unregister().then(() => window.location.reload())
  );
} else {
  if (sessionStorage.getItem(SW_CLEANUP_KEY)) sessionStorage.removeItem(SW_CLEANUP_KEY);
  runApp();
}
